import { useMemo } from 'react';
import { useLocalStorage } from 'react-use';
import { Button } from '../Button/Button';
import Empty from '../Empty/Empty';
import Segment from '../Segment/Segment';
import { logContexts } from './Logs.data';
import { Actions, Content, H1, Top, Wrapper } from './Logs.style';
import Log from './_parts/Log/Log';

export type LogsProps = {
  logs: ILog[];
  callbacks: {
    clearLogs: () => void;
  };
};

export function Logs(props: LogsProps) {
  const { logs, callbacks } = props;
  const [context, setContext] = useLocalStorage('LOG_CONTEXT', 'all');

  const filteredLogs = useMemo(() => {
    if (context === 'all') {
      return logs;
    }

    return logs.filter((log: ILog) => log.message.startsWith(context ?? ''));
  }, [context, logs]);

  function renderLog(log: ILog) {
    return <Log key={log.id} log={log} />;
  }

  function renderLogs() {
    if (!filteredLogs.length) {
      return <Empty>Empty list</Empty>;
    }

    return filteredLogs.map((log: ILog) => renderLog(log));
  }

  return (
    <Wrapper className='Logs-wrapper' data-testid='Logs-wrapper'>
      <Top>
        <H1>Logs</H1>
        <Actions>
          <Button variant='subtle' onClick={callbacks.clearLogs}>
            Clear Logs
          </Button>
        </Actions>
        <Segment data={logContexts} value={context ?? ''} onChange={(value) => setContext(value)} />
      </Top>
      <Content>{renderLogs()}</Content>
    </Wrapper>
  );
}

export default Logs;
